import React, { useCallback } from 'react'
import { View } from 'react-native'
import { AppRoutes } from 'navigations/app-routes'
import BottomTabBar from 'navigations/_components/BottomTabBar'
import { useHomeTabs } from 'navigations/home/tabs'
import HelperPlatform from 'utils/helper-platform'
import { useIsSmallDevice } from 'utils/helper-device'

const getSelectedTab = routeName => {
	if(
		routeName === AppRoutes.ADD_BOOKING ||
		routeName === AppRoutes.INVITATION_RECEIVED ||
		routeName === AppRoutes.INVITATION_SENT ||
		routeName === AppRoutes.INVITATION_LOGS ||
		routeName === AppRoutes.EVENTS ||
		routeName === AppRoutes.EVENT_VIEW
	) {
		return AppRoutes.TAB_BOOK;
	}

	if(
		routeName === AppRoutes.COWORKERS ||
		routeName === AppRoutes.COWORKERS_VIEW ||
		routeName === AppRoutes.COWORKERS_FILTER_SELECTION ||
		routeName === AppRoutes.COWORKERS_FILTER_RESULTS ||
		routeName === AppRoutes.ERO_COWORKER ||
		routeName === AppRoutes.CONFIDANT_COWORKER
	) {
		return AppRoutes.TAB_COWORKERS;
	}

	if( routeName === AppRoutes.MORE || routeName?.startsWith( 'more_' ) ) {
		return AppRoutes.TAB_MORE;
	}

	return AppRoutes.TAB_TODAY;
}

const DesktopNavigationFrame = ({ navigation, route, children }) => {
	const isSmallDevice = useIsSmallDevice();
	const tabs = useHomeTabs();

	const onTabPress = useCallback( ( props, index ) => {
		const routeName = tabs[ index ]?.name;
		if( routeName ) {
			navigation.navigate( AppRoutes.TABS, { screen: routeName } );
		}
	}, [ navigation, tabs ] );

	const isScanner = route?.name === AppRoutes.LUNCH_SCANNER || route?.name === AppRoutes.LUNCH_SLEEPING;
	if( isScanner || !HelperPlatform.isWeb() || isSmallDevice ) {
		return children;
	}

	const selectedTab = getSelectedTab( route?.name );
	const routeNames = tabs.map( tab => {
		return tab.name;
	} );
	const selectedIndex = Math.max( 0, routeNames.indexOf( selectedTab ) );

	return (
		<View style={ styles.container }>
			<BottomTabBar
				props={{
					state: {
						routeNames,
						index: selectedIndex,
					},
					navigation,
				}}
				tabs={ tabs }
				vertical
				onTabPress={ onTabPress }
			/>

			<View style={ styles.content }>
				{ children }
			</View>
		</View>
	);
}

const styles = {
	container: {
		flex: 1,
		flexDirection: 'row',
	},
	content: {
		flex: 1,
		minWidth: 0,
	},
};

export default DesktopNavigationFrame
